var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',{staticClass:"row",on:{"end":_vm.setNewOrder},model:{value:(_vm.images),callback:function ($$v) {_vm.images=$$v},expression:"images"}},_vm._l((_vm.images),function(item,index){return _c('b-col',{key:index,attrs:{"cols":"3"}},[_c('b-img',{attrs:{"src":item.image_small,"fluid":""}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }